// Angular
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
// Components
import {BaseComponent} from './views/theme/base/base.component';
import {AuthGuard} from './core/guards/auth.guard';
import {DroitsaccesGuard} from './core/guards/droitsacces.guard';


const routes: Routes = [
	{
		path: 'auth',
		loadChildren: () => import('app/views/modules/auth/auth.module').then(m => m.AuthModule)
	},
	{
		path: 'loading',
		canActivate: [AuthGuard],
		loadChildren: () => import('app/views/modules/loading/loading.module').then(m => m.LoadingModule)
	},

	{
		path: 'app',
		component: BaseComponent,
		canActivate: [AuthGuard, DroitsaccesGuard],
		data: {moduleName: 'espacedistributeur', moduleTitre: 'Tableau de bord'},
		children: [
			{
				path: 'clients',
				loadChildren: () => import('app/views/modules/clients/clients.module').then(m => m.ClientsModule)
			},
			{
				path: 'commissions',
				loadChildren: () => import('app/views/modules/commissions/commissions.module').then(m => m.CommissionsModule)
			},
			{
				path: 'tickets',
				loadChildren: () => import('app/views/modules/tickets/tickets.module').then(m => m.TicketsModule)
			},

			{
				path: 'tableaudebord',
				loadChildren: () => import('app/views/modules/tableaudebord/tableaudebord.module').then(m => m.TableaudebordModule)
			},



			{path: '', redirectTo: 'tableaudebord', pathMatch: 'full'},
			{path: '**', redirectTo: 'tableaudebord', pathMatch: 'full'}
		]
	},
	{
		path: 'pages',
		loadChildren: () => import('app/views/modules/pages/pages.module').then(m => m.PagesModule)
	},

	{path: '**', redirectTo: 'app', pathMatch: 'full'},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
